require('../modules/es6.symbol');
require('../modules/es6.object.to-string');
module.exports = require('../modules/_core').Symbol;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/es6/symbol.js
// module id = ./node_modules/core-js/es6/symbol.js
// module chunks = polyfills